export const truncate = (text: string, maxLength?: number) => {
    const initialMaxLength = maxLength || 17;
    return text?.length >= initialMaxLength ? text?.substring(0, initialMaxLength - 3) + '..' : text
}